import type { ArtifactKind, EvArtifact } from "../../types/agent-chat";

export const ARTIFACT_KIND_LABEL: Record<ArtifactKind, string> = {
  description_poste: "Description de poste",
  echelle_salariale: "Échelle salariale",
  document_modele: "Document",
};

/** Human title of a generated document: the job title or the scale's position. */
export function artifactTitle(artifact: EvArtifact): string {
  const fields = artifact.fields ?? {};
  const candidate = fields.titre ?? fields.poste;
  if (typeof candidate === "string" && candidate.trim()) return candidate.trim();
  return ARTIFACT_KIND_LABEL[artifact.kind] ?? artifact.kind;
}

export function artifactSubtitle(artifact: EvArtifact): string {
  const label = ARTIFACT_KIND_LABEL[artifact.kind] ?? artifact.kind;
  if (artifact.kind === "document_modele") {
    const modele = (artifact.fields?.modele ?? {}) as { titre?: string; source?: string };
    if (modele.source === "fourni") return `${label} · d'après le document fourni`;
    return modele.titre ? `${label} · modèle « ${modele.titre} »` : `${label} · sans modèle`;
  }
  return `${label} · gabarit ${artifact.template_id} v${artifact.template_version}`;
}
